import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ help, ...args }) {
    super(args)
    this.children = [
      {
        ...this.getComponentWithVModel('file-input'),
        props: {
          errors: this.getErrorsForPath(this.modelPath)
        }
      }
    ]
    if (help) {
      this.children.push({
        component: 'el-alert',
        attrs: {
          showIcon: true,
          closable: false,
          title: help
        }
      })
    }
  }
}
